module.exports = __webpack_public_path__ + "static/media/18.ac8975c1.jpg";